// @generated by protoc-gen-es v1.10.1 with parameter "target=ts,import_extension=none"
// @generated from file mono/document/v1/document.proto (package mono.document.v1, syntax proto3)
/* eslint-disable */ // @ts-nocheck
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { Message, proto3, protoInt64, Timestamp } from "@bufbuild/protobuf";
/**
 * @generated from message mono.document.v1.ProcessDocumentRequest
 */ export class ProcessDocumentRequest extends Message {
    static fromBinary(bytes, options) {
        return new ProcessDocumentRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProcessDocumentRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProcessDocumentRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProcessDocumentRequest, a, b);
    }
    constructor(data){
        super(), /**
   * Raw document bytes.
   *
   * @generated from field: bytes file_data = 1;
   */ _define_property(this, "fileData", new Uint8Array(0)), /**
   * Original filename.
   *
   * @generated from field: string filename = 2;
   */ _define_property(this, "filename", ""), /**
   * Content type (e.g., "application/pdf").
   *
   * @generated from field: string content_type = 3;
   */ _define_property(this, "contentType", ""), /**
   * Tenant ID for isolation.
   *
   * @generated from field: string tenant_id = 4;
   */ _define_property(this, "tenantId", ""), /**
   * Company ID (defaults to tenant_id).
   *
   * @generated from field: string company_id = 5;
   */ _define_property(this, "companyId", ""), /**
   * Project ID (optional).
   *
   * @generated from field: string project_id = 6;
   */ _define_property(this, "projectId", ""), /**
   * Output format (default: "markdown").
   *
   * @generated from field: string output_format = 7;
   */ _define_property(this, "outputFormat", ""), /**
   * Processing options.
   *
   * @generated from field: mono.document.v1.ProcessingOptions options = 8;
   */ _define_property(this, "options", void 0), /**
   * Artifact ID from tesoro/pangaea. When set, baltigo writes the
   * processed output at the shared go-common artifactstore key
   * ({tenant}/projects/{project}/processed/{artifact_id}.{ext}) so
   * tesoro's GetArtifactChunk can find it without an extra hop. Empty
   * for non-tesoro callers — they keep the legacy key behavior.
   *
   * @generated from field: string artifact_id = 9;
   */ _define_property(this, "artifactId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ProcessDocumentRequest, "runtime", proto3);
_define_property(ProcessDocumentRequest, "typeName", "mono.document.v1.ProcessDocumentRequest");
_define_property(ProcessDocumentRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "file_data",
            kind: "scalar",
            T: 12 /* ScalarType.BYTES */ 
        },
        {
            no: 2,
            name: "filename",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "content_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "output_format",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "options",
            kind: "message",
            T: ProcessingOptions
        },
        {
            no: 9,
            name: "artifact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.document.v1.ProcessingOptions
 */ export class ProcessingOptions extends Message {
    static fromBinary(bytes, options) {
        return new ProcessingOptions().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProcessingOptions().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProcessingOptions().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProcessingOptions, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: bool use_deep_processing = 1;
   */ _define_property(this, "useDeepProcessing", false), /**
   * @generated from field: bool extract_tables = 2;
   */ _define_property(this, "extractTables", false), /**
   * @generated from field: bool extract_images = 3;
   */ _define_property(this, "extractImages", false), /**
   * @generated from field: bool preserve_layout = 4;
   */ _define_property(this, "preserveLayout", false), /**
   * @generated from field: int32 chunk_size = 5;
   */ _define_property(this, "chunkSize", 0), /**
   * @generated from field: int32 overlap_size = 6;
   */ _define_property(this, "overlapSize", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ProcessingOptions, "runtime", proto3);
_define_property(ProcessingOptions, "typeName", "mono.document.v1.ProcessingOptions");
_define_property(ProcessingOptions, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "use_deep_processing",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 2,
            name: "extract_tables",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 3,
            name: "extract_images",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 4,
            name: "preserve_layout",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 5,
            name: "chunk_size",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 6,
            name: "overlap_size",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.document.v1.ProcessDocumentResponse
 */ export class ProcessDocumentResponse extends Message {
    static fromBinary(bytes, options) {
        return new ProcessDocumentResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProcessDocumentResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProcessDocumentResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProcessDocumentResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string status = 3;
   */ _define_property(this, "status", ""), /**
   * @generated from field: repeated mono.document.v1.DocumentChunk chunks = 4;
   */ _define_property(this, "chunks", []), /**
   * @generated from field: mono.document.v1.DocumentMetadata metadata = 5;
   */ _define_property(this, "metadata", void 0), /**
   * MinIO storage paths for processed outputs (populated after async processing completes)
   *
   * @generated from field: string markdown_path = 6;
   */ _define_property(this, "markdownPath", ""), /**
   * @generated from field: string html_path = 7;
   */ _define_property(this, "htmlPath", ""), /**
   * @generated from field: string json_path = 8;
   */ _define_property(this, "jsonPath", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ProcessDocumentResponse, "runtime", proto3);
_define_property(ProcessDocumentResponse, "typeName", "mono.document.v1.ProcessDocumentResponse");
_define_property(ProcessDocumentResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "chunks",
            kind: "message",
            T: DocumentChunk,
            repeated: true
        },
        {
            no: 5,
            name: "metadata",
            kind: "message",
            T: DocumentMetadata
        },
        {
            no: 6,
            name: "markdown_path",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "html_path",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "json_path",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.document.v1.GetDocumentStatusRequest
 */ export class GetDocumentStatusRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetDocumentStatusRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetDocumentStatusRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetDocumentStatusRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetDocumentStatusRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetDocumentStatusRequest, "runtime", proto3);
_define_property(GetDocumentStatusRequest, "typeName", "mono.document.v1.GetDocumentStatusRequest");
_define_property(GetDocumentStatusRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.document.v1.GetDocumentStatusResponse
 */ export class GetDocumentStatusResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetDocumentStatusResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetDocumentStatusResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetDocumentStatusResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetDocumentStatusResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string status = 2;
   */ _define_property(this, "status", ""), /**
   * @generated from field: mono.document.v1.DocumentMetadata metadata = 3;
   */ _define_property(this, "metadata", void 0), /**
   * @generated from field: repeated mono.document.v1.DocumentChunk chunks = 4;
   */ _define_property(this, "chunks", []), /**
   * Error message when status is "error" or "failed".
   *
   * @generated from field: string error_message = 5;
   */ _define_property(this, "errorMessage", ""), /**
   * MinIO storage paths of the processed artifacts — the async pollers
   * (reverie) consume THIS response, not ProcessDocument's, so omitting them
   * here silently dropped json_path pipeline-wide: downstream blocks.json got
   * built from HTML (no geometry, 0-based pages) instead of the datalab JSON.
   *
   * @generated from field: string markdown_path = 6;
   */ _define_property(this, "markdownPath", ""), /**
   * @generated from field: string html_path = 7;
   */ _define_property(this, "htmlPath", ""), /**
   * @generated from field: string json_path = 8;
   */ _define_property(this, "jsonPath", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetDocumentStatusResponse, "runtime", proto3);
_define_property(GetDocumentStatusResponse, "typeName", "mono.document.v1.GetDocumentStatusResponse");
_define_property(GetDocumentStatusResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "metadata",
            kind: "message",
            T: DocumentMetadata
        },
        {
            no: 4,
            name: "chunks",
            kind: "message",
            T: DocumentChunk,
            repeated: true
        },
        {
            no: 5,
            name: "error_message",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "markdown_path",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "html_path",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "json_path",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.document.v1.DownloadDocumentRequest
 */ export class DownloadDocumentRequest extends Message {
    static fromBinary(bytes, options) {
        return new DownloadDocumentRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DownloadDocumentRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DownloadDocumentRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DownloadDocumentRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DownloadDocumentRequest, "runtime", proto3);
_define_property(DownloadDocumentRequest, "typeName", "mono.document.v1.DownloadDocumentRequest");
_define_property(DownloadDocumentRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.document.v1.DownloadDocumentResponse
 */ export class DownloadDocumentResponse extends Message {
    static fromBinary(bytes, options) {
        return new DownloadDocumentResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DownloadDocumentResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DownloadDocumentResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DownloadDocumentResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: bytes data = 1;
   */ _define_property(this, "data", new Uint8Array(0)), /**
   * @generated from field: string filename = 2;
   */ _define_property(this, "filename", ""), /**
   * @generated from field: string content_type = 3;
   */ _define_property(this, "contentType", ""), /**
   * @generated from field: string format = 4;
   */ _define_property(this, "format", ""), /**
   * @generated from field: string status = 5;
   */ _define_property(this, "status", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DownloadDocumentResponse, "runtime", proto3);
_define_property(DownloadDocumentResponse, "typeName", "mono.document.v1.DownloadDocumentResponse");
_define_property(DownloadDocumentResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "data",
            kind: "scalar",
            T: 12 /* ScalarType.BYTES */ 
        },
        {
            no: 2,
            name: "filename",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "content_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "format",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.document.v1.ListDocumentsRequest
 */ export class ListDocumentsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListDocumentsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListDocumentsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListDocumentsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListDocumentsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: int32 limit = 1;
   */ _define_property(this, "limit", 0), /**
   * @generated from field: int32 offset = 2;
   */ _define_property(this, "offset", 0), /**
   * Optional status filter (e.g., "processing", "completed", "failed").
   *
   * @generated from field: string status = 3;
   */ _define_property(this, "status", ""), /**
   * Sort field: "recent" (default, by created_at desc) or "name" (by filename asc).
   *
   * @generated from field: string sort_by = 4;
   */ _define_property(this, "sortBy", ""), /**
   * Project scope: return the PROJECT's documents (every member's uploads,
   * tenant-scoped) instead of the caller's personal library. The project
   * documents view rides this; access follows project membership, which the
   * caller proved by loading the project through zou.
   *
   * @generated from field: string project_id = 5;
   */ _define_property(this, "projectId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListDocumentsRequest, "runtime", proto3);
_define_property(ListDocumentsRequest, "typeName", "mono.document.v1.ListDocumentsRequest");
_define_property(ListDocumentsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "limit",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 2,
            name: "offset",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "sort_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.document.v1.ListDocumentsResponse
 */ export class ListDocumentsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListDocumentsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListDocumentsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListDocumentsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListDocumentsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.document.v1.DocumentListItem documents = 1;
   */ _define_property(this, "documents", []), /**
   * @generated from field: mono.document.v1.DocumentPagination pagination = 2;
   */ _define_property(this, "pagination", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListDocumentsResponse, "runtime", proto3);
_define_property(ListDocumentsResponse, "typeName", "mono.document.v1.ListDocumentsResponse");
_define_property(ListDocumentsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "documents",
            kind: "message",
            T: DocumentListItem,
            repeated: true
        },
        {
            no: 2,
            name: "pagination",
            kind: "message",
            T: DocumentPagination
        }
    ]));
/**
 * @generated from message mono.document.v1.DocumentListItem
 */ export class DocumentListItem extends Message {
    static fromBinary(bytes, options) {
        return new DocumentListItem().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DocumentListItem().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DocumentListItem().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DocumentListItem, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string filename = 2;
   */ _define_property(this, "filename", ""), /**
   * @generated from field: string content_type = 3;
   */ _define_property(this, "contentType", ""), /**
   * @generated from field: int64 size = 4;
   */ _define_property(this, "size", protoInt64.zero), /**
   * @generated from field: string status = 5;
   */ _define_property(this, "status", ""), /**
   * @generated from field: string output_format = 6;
   */ _define_property(this, "outputFormat", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 7;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 8;
   */ _define_property(this, "updatedAt", void 0), /**
   * @generated from field: string error_message = 9;
   */ _define_property(this, "errorMessage", ""), /**
   * Project the document was processed under ("" for a standalone upload).
   * Lets the library file a document under its project instead of showing
   * every row as an unplaced, general document.
   *
   * @generated from field: string project_id = 10;
   */ _define_property(this, "projectId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DocumentListItem, "runtime", proto3);
_define_property(DocumentListItem, "typeName", "mono.document.v1.DocumentListItem");
_define_property(DocumentListItem, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "filename",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "content_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "size",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        },
        {
            no: 5,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "output_format",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 8,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 9,
            name: "error_message",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.document.v1.DocumentPagination
 */ export class DocumentPagination extends Message {
    static fromBinary(bytes, options) {
        return new DocumentPagination().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DocumentPagination().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DocumentPagination().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DocumentPagination, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: int32 total = 1;
   */ _define_property(this, "total", 0), /**
   * @generated from field: int32 limit = 2;
   */ _define_property(this, "limit", 0), /**
   * @generated from field: int32 offset = 3;
   */ _define_property(this, "offset", 0), /**
   * @generated from field: bool has_more = 4;
   */ _define_property(this, "hasMore", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(DocumentPagination, "runtime", proto3);
_define_property(DocumentPagination, "typeName", "mono.document.v1.DocumentPagination");
_define_property(DocumentPagination, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "total",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 2,
            name: "limit",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "offset",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "has_more",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.document.v1.DeleteDocumentsRequest
 */ export class DeleteDocumentsRequest extends Message {
    static fromBinary(bytes, options) {
        return new DeleteDocumentsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteDocumentsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteDocumentsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteDocumentsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated string ids = 1;
   */ _define_property(this, "ids", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteDocumentsRequest, "runtime", proto3);
_define_property(DeleteDocumentsRequest, "typeName", "mono.document.v1.DeleteDocumentsRequest");
_define_property(DeleteDocumentsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.document.v1.DeleteDocumentsResponse
 */ export class DeleteDocumentsResponse extends Message {
    static fromBinary(bytes, options) {
        return new DeleteDocumentsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteDocumentsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteDocumentsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteDocumentsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: int32 deleted = 1;
   */ _define_property(this, "deleted", 0), /**
   * @generated from field: repeated string failed_ids = 2;
   */ _define_property(this, "failedIds", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteDocumentsResponse, "runtime", proto3);
_define_property(DeleteDocumentsResponse, "typeName", "mono.document.v1.DeleteDocumentsResponse");
_define_property(DeleteDocumentsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "deleted",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 2,
            name: "failed_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * DocumentChunk is a portion of a processed document.
 *
 * @generated from message mono.document.v1.DocumentChunk
 */ export class DocumentChunk extends Message {
    static fromBinary(bytes, options) {
        return new DocumentChunk().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DocumentChunk().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DocumentChunk().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DocumentChunk, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string content = 2;
   */ _define_property(this, "content", ""), /**
   * @generated from field: int32 index = 3;
   */ _define_property(this, "index", 0), /**
   * @generated from field: map<string, string> metadata = 4;
   */ _define_property(this, "metadata", {});
        proto3.util.initPartial(data, this);
    }
}
_define_property(DocumentChunk, "runtime", proto3);
_define_property(DocumentChunk, "typeName", "mono.document.v1.DocumentChunk");
_define_property(DocumentChunk, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "content",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "index",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "metadata",
            kind: "map",
            K: 9 /* ScalarType.STRING */ ,
            V: {
                kind: "scalar",
                T: 9 /* ScalarType.STRING */ 
            }
        }
    ]));
/**
 * DocumentMetadata holds metadata about a processed document.
 *
 * @generated from message mono.document.v1.DocumentMetadata
 */ export class DocumentMetadata extends Message {
    static fromBinary(bytes, options) {
        return new DocumentMetadata().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DocumentMetadata().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DocumentMetadata().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DocumentMetadata, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string filename = 1;
   */ _define_property(this, "filename", ""), /**
   * @generated from field: string content_type = 2;
   */ _define_property(this, "contentType", ""), /**
   * @generated from field: int64 size_bytes = 3;
   */ _define_property(this, "sizeBytes", protoInt64.zero), /**
   * @generated from field: int32 page_count = 4;
   */ _define_property(this, "pageCount", 0), /**
   * @generated from field: int32 chunk_count = 5;
   */ _define_property(this, "chunkCount", 0), /**
   * @generated from field: string format = 6;
   */ _define_property(this, "format", ""), /**
   * @generated from field: google.protobuf.Timestamp processed_at = 7;
   */ _define_property(this, "processedAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(DocumentMetadata, "runtime", proto3);
_define_property(DocumentMetadata, "typeName", "mono.document.v1.DocumentMetadata");
_define_property(DocumentMetadata, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "filename",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "content_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "size_bytes",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        },
        {
            no: 4,
            name: "page_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 5,
            name: "chunk_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 6,
            name: "format",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "processed_at",
            kind: "message",
            T: Timestamp
        }
    ]));
